<template>
  <div>
    <vue-slideout-panel
      v-model="showInfoDialog"
      :widths="['40%']"
      close-html="<i class='fal fa-lg fa-times'></i>"
      @close="showInfoDialog = false"
    >
      <cash-register-report-info :report-object="reportInfo" />
    </vue-slideout-panel>
    <v-data-table
      v-bind="dataTableProps"
      :headers="headers"
      :items="reports"
      :loading="$wait.is('fetching reports')"
      :options.sync="pagination"
      :server-items-length="nrOfReports"
      sort-by="nr"
      sort-desc
    >
      <template v-slot:item="props">
        <tr
          :key="props.item.uuid"
          style="cursor: pointer"
          @click="showInfo(props.item)"
        >
          <td>{{ props.item.cashRegister.description }}</td>
          <td>{{ props.item.nr }}</td>
          <td>{{ props.item.created | moment("D MMMM YYYY HH:mm") }}</td>
          <td>{{ props.item.closed | moment("D MMMM YYYY HH:mm") }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import cashRegisterService from '@/services/cash-registers'
import camelcaseKeys from 'camelcase-keys'
import VueSlideoutPanel from 'vue-slideout-panel'
import CashRegisterReportInfo from '@/components/cash-register-reports/CashRegisterReportInfo'
import { VDataTableDefaultProps as dataTableProps } from '@/utils/default-props/v-data-table'

export default {
  name: 'CashRegisterReportsTable',

  components: {
    VueSlideoutPanel,
    CashRegisterReportInfo
  },

  data () {
    return {
      conditions: {},
      headers: [
        {
          text: this.$t('Cash Register'),
          value: 'cash_register_id',
          width: '20%'
        },
        {
          text: this.$t('Nr'),
          value: 'nr',
          width: '20%'
        },
        {
          text: this.$t('Opened'),
          value: 'created',
          width: '20%'
        },
        {
          text: this.$t('Closed'),
          value: 'closed',
          width: '20%'
        }
      ],
      nrOfReports: 0,
      pagination: {},
      reportInfo: null,
      reports: [],
      showInfoDialog: false,
      dataTableProps
    }
  },

  watch: {
    // fetch reports when requested page or sorting changed
    pagination (value) {
      this.updateResults()
    }
  },

  methods: {
    updateResults () {
      this.$wait.start('fetching reports')
      // reset dataset
      this.reports = []

      cashRegisterService.paginationReports(this.conditions, this.pagination)
        .then((data) => {
          if (data.data) {
            this.reports = camelcaseKeys(data.data.reports, { deep: true })
            this.nrOfReports = data.data.total_count
          }
        })
        .finally((data) => this.$wait.end('fetching reports'))
    },
    showInfo (item) {
      this.reportInfo = item
      this.showInfoDialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cash-register-reports/CashRegisterReportsTable.vue